import React from 'react';

export default function TwitterIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={48}
      height={48}
      viewBox="0 0 48 48"
    >
      <rect width={48} height={48} rx={3} fill="#41aaf1" />
      <path
        d="M38.239 14.824a12.055 12.055 0 01-3.466.974 6.067 6.067 0 002.649-3.36 12.162 12.162 0 01-3.833 1.482A5.948 5.948 0 0029.136 12a6.044 6.044 0 00-6.017 6.056 6.306 6.306 0 00.155 1.384 17.172 17.172 0 01-12.456-6.325 6 6 0 00-.817 3.036 5.962 5.962 0 002.691 5.025 5.969 5.969 0 01-2.748-.706v.042a6.058 6.058 0 004.847 5.944 5.916 5.916 0 01-2.72.1 6.032 6.032 0 005.636 4.207 11.993 11.993 0 01-7.51 2.6 12.268 12.268 0 01-1.436-.088A17.089 17.089 0 0018.033 36c11.1 0 17.2-9.233 17.2-17.238 0-.268 0-.522-.014-.791a12.091 12.091 0 003.02-3.147z"
        fill="#fff"
      />
    </svg>
  );
}
